<template>
  <div id="footer" class="footer">
    <div class="footer-row">
      <div class="footer-center">
        {{ copyright }}
      </div>
      <div class="license-text">
        LICENSED: <span class="license-name">{{ licenseName }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      copyright: 'Copyright (C) Transact2 Sdn Bhd. All Rights Reserved. 2025.',
      licenseName : localStorage.getItem('licenseName') || 'N/A'
    }
  }
}
</script>

<style>
.footer {
  bottom: 0;
  margin: 0 auto;
  text-align: center;
  width: 100%;
  position: fixed;
  background: #4D4D4D;
  color: white;
  padding: 16px 0;
}

/* flex layout */
.footer-row {
  display: flex;
  justify-content: center;   /* centers the middle */
  align-items: center;
  width: 100%;
  position: relative;
}

.footer-center {
  text-align: center;
  flex: 1; /* take full space between left and right */
}

.license-text {
  font-size: 14px;
  text-align: right;
  padding-right: 15px;
  margin-left: auto; /* pushes it to the right */
  color: black;
}

.license-name {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Footer.vue